import CheckCircle from "@assets/images/check-circle.svg";
import { Box, Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";

interface DialogSuccessProps {
  isOpen: boolean;
  onClose: () => void;
  records: string;
}

const useStyles = makeStyles(
  () => ({
    dialog: {
      maxWidth: "80vw",
      maxHeight: "80vh",
      overflowY: "auto",
      padding: "32px 24px 32px 24px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px"
    },
    modalBg: {
      borderRadius: "16px"
    },
    title: {
      fontSize: "20px",
      fontWeight: 700
    },
    checkCircle: {
      height: "40px",
      width: "40px"
    },
    button: {
      alignSelf: "center",
      backgroundColor: "#009FB8",
      borderRadius: "4px",
      width: "100%",
      minHeight: "48px",
      fontSize: "18px"
    },
    buttonTitle: {
      color: "white",
      fontSize: "18px"
    },
    fileResult: {
      paddingTop: "8px",
      paddingBottom: "24px",
      fontSize: "20px",
      wordWrap: "break-word"
    }
  }),
  { name: "DialogSuccess" }
);

const DialogSuccess = ({ isOpen, onClose, records }: DialogSuccessProps) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog
      open={isOpen}
      keepMounted
      onClose={onClose}
      className={classes.modalBg}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
    >
      <Box
        className={classes.dialog}
        display="flex"
        flexDirection={"column"}
        textAlign={"center"}
      >
        <Box>
          <img
            src={CheckCircle}
            alt="success"
            className={classes.checkCircle}
          />
        </Box>
        <Typography className={classes.fileResult}>
          {intl.formatMessage({
            defaultMessage: "อัปโหลดไฟล์ Master - Customer Material",
            description: "file"
          })}
          <br />
          <b>
            {intl.formatMessage({
              defaultMessage: "สำเร็จ",
              description: "file"
            })}
          </b>
          <br />
          {intl.formatMessage({
            defaultMessage: "Total Records: ",
            description: "Total Records"
          })}
          <span style={{ wordWrap: "break-word" }}>{records}</span>
        </Typography>

        <Button className={classes.button} onClick={onClose}>
          <Typography className={classes.buttonTitle}>
            {intl.formatMessage({
              defaultMessage: "ปิดหน้าต่าง",
              description: "close"
            })}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default DialogSuccess;
